import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersMembersApi,
  partnersMembersApiKeys,
} from '@/api/routes/partners/partners.members.api';

/** Remove an editor or a viewer; errors go to the global snackbar. */
export const usePartnersRemoveMember = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => partnersMembersApi.remove(userId),
    onSettled: () => queryClient.invalidateQueries({ queryKey: partnersMembersApiKeys.all }),
  });
};
